module.exports = __webpack_public_path__ + "media/images/map_preview_portrait-34ac02d05cf4996620b49df14247feb3.png";